import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    outerContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    innerContainer: {
      background: 'white',
      minWidth: '100%',
      borderRadius: '8px',
      height: '809px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      padding: '32px 64px 40px 64px',
      [theme.breakpoints.down('lg')]: {
        height: '1640px'
      }
    },
    headerContainer: {
      padding: '0 0 16px',
      width: '100%'
    },
    allItemsContainer: {
      display: 'flex',
      justifyContent: 'center',
      height: '461px',
      background: 'transparent',
      flexDirection: 'row',
      marginBottom: '40px',
      minWidth: '100%',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        height: 'fit-content',
        marginBottom: '23px'
      }
    },
    itemContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 16px 0px 16px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
        margin: '20px 0',
        padding: '0px'
      }
    },
    itemContentContainer: {
      flexDirection: 'column',
      width: '365px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
        width: '755px',
        height: '250px'
      }
    },
    itemImageContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      height: '275px',
      background: 'transparent',
      overflow: 'hidden',
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        width: '333px',
        height: '100%',
        alignItems: 'normal'
      }
    },
    itemDefaultImage: {
      height: '100%',
      objectFit: 'cover',
      [theme.breakpoints.down('lg')]: {
        width: 'auto'
      }
    },
    itemImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: '8px 8px 0px 0px',
      [theme.breakpoints.down('lg')]: {
        borderRadius: '8px 0px 0px 8px'
      }
    },
    itemHorizontalDivider: {
      marginTop: '-1px',
      padding: '0px 24px',
      background: 'transparent',
      maxHeight: '5px',
      display: 'block',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    itemVerticalDivider: {
      display: 'none',
      margin: '0px 32px 0px 0px',
      background: 'rgba(155,155,155)',
      height: '248px',
      width: '1px',
      [theme.breakpoints.down('lg')]: {
        display: 'block'
      }
    },
    itemTextContainer: {
      display: 'flex',
      justifyContent: 'space-around',
      height: '185px',
      background: 'transparent',
      padding: '10px 24px',
      alignItems: 'stretch',
      [theme.breakpoints.down('lg')]: {
        justifyContent: 'center',
        width: '371px',
        padding: '0px 10px 0px 10px',
        height: '100%'
      }
    },
    errorOverlayTitle: {
      fontSize: '64px',
      fontWeight: 600,
      textAlign: 'center',
      lineHeight: 1,
      margin: '0px 0px 24px 0px',
      width: '910px',
      letterSpacing: 'normal',
      [theme.breakpoints.down('lg')]: {
        width: '800px'
      }
    },
    errorOverlayDescription: {
      fontSize: '30px',
      textAlign: 'center',
      letterSpacing: 'normal',
      width: '710px',
      [theme.breakpoints.down('lg')]: {
        width: '600px'
      }
    }
  })
);
